var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 19.5H13.5V24.5C13.5 27.2614 11.2614 29.5 8.5 29.5C5.73858 29.5 3.5 27.2614 3.5 24.5V19.5Z",
    fill: "#FFB6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5879 17L33.0879 27.5C35.0879 26.5 37.0879 21 33.5879 17.5C28.9489 12.861 24.7546 15.1667 22.5879 17Z",
    fill: "#FFB6BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 16C23.9101 16 21 18.9101 21 22.5C21 26.0899 23.9101 29 27.5 29C31.0899 29 34 26.0899 34 22.5C34 18.9101 31.0899 16 27.5 16ZM18 22.5C18 17.2533 22.2533 13 27.5 13C32.7467 13 37 17.2533 37 22.5C37 27.7467 32.7467 32 27.5 32C22.2533 32 18 27.7467 18 22.5Z",
    fill: "#3D0E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12.5C1 8.35786 4.35786 5 8.5 5C12.6421 5 16 8.35786 16 12.5V24.5C16 28.6421 12.6421 32 8.5 32C4.35786 32 1 28.6421 1 24.5V12.5ZM8.5 8C6.01472 8 4 10.0147 4 12.5V24.5C4 26.9853 6.01472 29 8.5 29C10.9853 29 13 26.9853 13 24.5V12.5C13 10.0147 10.9853 8 8.5 8Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPills);
export default __webpack_public_path__ + "static/media/ic_pills.c13674fb98900a64674fefa1b07ca280.svg";
export { ForwardRef as ReactComponent };